// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rs-picker-menu {
    z-index: 1400 !important; /* Adjust the z-index value as needed */
  }

  
  .base-Popper-root {
    z-index: 1400 !important; }

.css-1ols1k-MuiPopper-root {
    z-index: 1400 !important; }

    .rs-checkbox-checked .rs-checkbox-wrapper .rs-checkbox-inner::before,
.rs-checkbox-indeterminate .rs-checkbox-wrapper .rs-checkbox-inner::before {
    border-color: #106881 !important
    ;
    background-color: #106881 !important
    ;
}
rs-picker-has-value .rs-btn .rs-picker-toggle-value,
.rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value {
    color:  #000000 !important;
}
.rs-picker-value-count {
    /* Add your custom styles here */
    color: #ffffff; /* Change text color to white */
    background-color: #106881 !important; /* Change background color to blue */
    padding: 4px 8px; /* Add padding around the count */
    border-radius: 50%; /* Make the count badge round */
    font-size: 13px; /* Adjust font size */
}
.rs-radio-wrapper{
    top: 0px!important;
}
.rs-radio-checker{
    min-height: 0px!important;
    padding-top: 0px!important;
    padding-bottom: 0px!important;

}
`, "",{"version":3,"sources":["webpack://./src/components/MgpMulticascader.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB,EAAE,uCAAuC;EACnE;;;EAGA;IACE,wBAAwB,EAAE;;AAE9B;IACI,wBAAwB,EAAE;;IAE1B;;IAEA;IACA;IACA;IACA;AACJ;AACA;;IAEI,0BAA0B;AAC9B;AACA;IACI,gCAAgC;IAChC,cAAc,EAAE,+BAA+B;IAC/C,oCAAoC,EAAE,oCAAoC;IAC1E,gBAAgB,EAAE,iCAAiC;IACnD,kBAAkB,EAAE,+BAA+B;IACnD,eAAe,EAAE,qBAAqB;AAC1C;AACA;IACI,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,6BAA6B;;AAEjC","sourcesContent":[".rs-picker-menu {\n    z-index: 1400 !important; /* Adjust the z-index value as needed */\n  }\n\n  \n  .base-Popper-root {\n    z-index: 1400 !important; }\n\n.css-1ols1k-MuiPopper-root {\n    z-index: 1400 !important; }\n\n    .rs-checkbox-checked .rs-checkbox-wrapper .rs-checkbox-inner::before,\n.rs-checkbox-indeterminate .rs-checkbox-wrapper .rs-checkbox-inner::before {\n    border-color: #106881 !important\n    ;\n    background-color: #106881 !important\n    ;\n}\nrs-picker-has-value .rs-btn .rs-picker-toggle-value,\n.rs-picker-has-value .rs-picker-toggle .rs-picker-toggle-value {\n    color:  #000000 !important;\n}\n.rs-picker-value-count {\n    /* Add your custom styles here */\n    color: #ffffff; /* Change text color to white */\n    background-color: #106881 !important; /* Change background color to blue */\n    padding: 4px 8px; /* Add padding around the count */\n    border-radius: 50%; /* Make the count badge round */\n    font-size: 13px; /* Adjust font size */\n}\n.rs-radio-wrapper{\n    top: 0px!important;\n}\n.rs-radio-checker{\n    min-height: 0px!important;\n    padding-top: 0px!important;\n    padding-bottom: 0px!important;\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
